import React, { useEffect, useState } from "react";
import { CalendarX } from "lucide-react";
import CustomModal from "../CustomModal/CustomModal";
import { EVENT_CANCELLED_NOTICE_EVENT, EVENT_CANCELLED_MESSAGE } from "../../../utils/eventCancelledNotice";
// Same dialog look as the account status popup
import "../AccountStatusModal/AccountStatusModal.scss";

// Popup for a cancelled-event notification: the event no longer exists, so the notification opens the events
// list and this explains why. Mounted once in App.js and opened with showEventCancelledNotice().
// notice: null = closed
const EventCancelledNotice = () => {
  const [notice, setNotice] = useState(null);

  useEffect(() => {
    const open = (e) =>
      setNotice({
        message: e.detail?.message || EVENT_CANCELLED_MESSAGE,
        eventName: e.detail?.eventName || "",
      });
    window.addEventListener(EVENT_CANCELLED_NOTICE_EVENT, open);
    return () => window.removeEventListener(EVENT_CANCELLED_NOTICE_EVENT, open);
  }, []);

  const close = () => setNotice(null);

  return (
    <CustomModal show={notice !== null} onClose={close} title="" className="account-status-modal">
      <div className="account_status_container">
        <div className="account_status_icon">
          <CalendarX size={26} strokeWidth={1.8} aria-hidden="true" />
        </div>
        <h2>Event cancelled</h2>
        <p>
          {notice?.eventName && (
            <>
              <strong style={{ color: "#1f2233" }}>{notice.eventName}</strong>
              <br />
            </>
          )}
          {notice?.message}
        </p>
        <button type="button" className="account_status_btn" onClick={close}>
          Got it
        </button>
      </div>
    </CustomModal>
  );
};

export default EventCancelledNotice;
